import { Theme } from '../../../src/types/index.js'

export const theme: Theme = {
  id: 'peachy-rose',
  name: 'Peachy rose',
  palette: {
    primary: '#F4403D',
    accent: '#0081E6',
    neutral: '#F0F4FC',
  },
  light1: {
    'action-primary': '#ef5145',
    'action-primary-hovered': '#f46e64',
    'action-primary-pressed': '#e64438',
    'action-primary-subdued': '#fff5f3',
    'action-primary-subdued-hovered': '#fff0ed',
    'action-primary-subdued-pressed': '#ffe0da',
    'action-primary-disabled': '#f7f7f7',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#f4f8fe',
    'action-neutral-pressed': '#e7f0ff',
    'action-neutral-subdued': '#f2f2f2',
    'action-neutral-subdued-hovered': '#e6e6e6',
    'action-neutral-subdued-pressed': '#d4d4d4',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f2f2f2',
    background: '#f2f6fc',
    'background-hovered': '#fffefe',
    'background-pressed': '#FFEDEC',
    'background-selected': '#ffd3d1',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#a1a1a1',
    content: '#1a1c20',
    'content-subdued': '#26292f',
    'content-muted': '#5b5e66',
    'content-hovered': '#26292f',
    'content-pressed': '#535353',
    'content-disabled': '#a1a1a1',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00294b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#ef5145',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f7f7f7',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#1a1c20',
    'content-on-background-subdued': '#26292f',
    'content-on-background-hovered': '#26292f',
    'content-on-background-pressed': '#f16157',
    'content-on-background-disabled': '#a1a1a1',
    interactive: '#ef5145',
    'interactive-hovered': '#f46e64',
    'interactive-pressed': '#e64438',
    'interactive-disabled': '#f7f7f7',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f7f7f7',
    topbar: '#FFFFFF',
    'topbar-subdued': '#f2f6fc',
    'content-on-topbar': '#060606',
    'line-on-topbar': '#d4d4d4',
    'line-on-topbar-pressed': '#727272',
    link: '#0f90ec',
    'link-hovered': '#006cb9',
    'link-pressed': '#0f90ec',
    line: '#d4d4d4',
    'line-subdued': '#f2f6fc',
    'line-hovered': '#a1a1a1',
    'line-pressed': '#727272',
    'line-selected': '#535353',
    'line-disabled': '#e6e6e6',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005791',
    'line-highlight-subdued': '#a5dbff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#0f90ec',
    skeleton: '#f3e2e2',
    surface: '#FFFFFF',
    'surface-subdued': '#f2f6fc',
    'surface-hovered': '#f3f7fc',
    'surface-subdued-hovered': '#fcfeff',
    'surface-pressed': '#e7f0ff',
    'surface-disabled': '#f7f7f7',
    'surface-selected': '#f2f6fc',
    'surface-selected-hovered': '#fff0ed',
    'surface-selected-pressed': '#ffe0da',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#cdebff',
    'surface-highlight-subdued': '#f0f8ff',
    'surface-highlight-subdued-hovered': '#e6f5ff',
    'surface-highlight-subdued-pressed': '#cdebff',
    'surface-neutral': '#f2f6fc',
    'surface-neutral-subdued': '#f7f7f7',
    'surface-inverse': '#171717',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light2: {
    'action-primary': '#ef5145',
    'action-primary-hovered': '#f46e64',
    'action-primary-pressed': '#e64438',
    'action-primary-subdued': '#fff5f3',
    'action-primary-subdued-hovered': '#fff0ed',
    'action-primary-subdued-pressed': '#ffe0da',
    'action-primary-disabled': '#f7f7f7',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#f4f8fe',
    'action-neutral-pressed': '#e7f0ff',
    'action-neutral-subdued': '#f2f2f2',
    'action-neutral-subdued-hovered': '#e6e6e6',
    'action-neutral-subdued-pressed': '#d4d4d4',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f2f2f2',
    background: '#FFFFFF',
    'background-hovered': '#f2f6fc',
    'background-pressed': '#fff0ed',
    'background-selected': '#e5ebf3',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#a1a1a1',
    content: '#1a1c20',
    'content-subdued': '#26292f',
    'content-muted': '#727272',
    'content-hovered': '#26292f',
    'content-pressed': '#3bbee1',
    'content-disabled': '#a1a1a1',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00294b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#ef5145',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f7f7f7',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#1a1c20',
    'content-on-background-subdued': '#26292f',
    'content-on-background-hovered': '#26292f',
    'content-on-background-pressed': '#ef5145',
    'content-on-background-disabled': '#a1a1a1',
    interactive: '#ef5145',
    'interactive-hovered': '#f46e64',
    'interactive-pressed': '#e64438',
    'interactive-disabled': '#f7f7f7',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f7f7f7',
    topbar: '#FFFFFF',
    'topbar-subdued': '#f2f6fc',
    'content-on-topbar': '#060606',
    'line-on-topbar': '#d4d4d4',
    'line-on-topbar-pressed': '#727272',
    link: '#0f90ec',
    'link-hovered': '#006cb9',
    'link-pressed': '#0f90ec',
    line: '#d4d4d4',
    'line-subdued': '#f2f6fc',
    'line-hovered': '#a1a1a1',
    'line-pressed': '#727272',
    'line-selected': '#535353',
    'line-disabled': '#e6e6e6',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005791',
    'line-highlight-subdued': '#a5dbff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#0f90ec',
    skeleton: '#faf4f4',
    surface: '#FFFFFF',
    'surface-subdued': '#fcfeff',
    'surface-hovered': '#f3f7fc',
    'surface-subdued-hovered': '#fcfeff',
    'surface-pressed': '#e7f0ff',
    'surface-disabled': '#f7f7f7',
    'surface-selected': '#f2f6fc',
    'surface-selected-hovered': '#fff0ed',
    'surface-selected-pressed': '#ffe0da',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#cdebff',
    'surface-highlight-subdued': '#f0f8ff',
    'surface-highlight-subdued-hovered': '#e6f5ff',
    'surface-highlight-subdued-pressed': '#cdebff',
    'surface-neutral': '#f2f6fc',
    'surface-neutral-subdued': '#f7f7f7',
    'surface-inverse': '#171717',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light3: {
    'action-primary': '#ef5145',
    'action-primary-hovered': '#f46e64',
    'action-primary-pressed': '#e64438',
    'action-primary-subdued': '#fff5f3',
    'action-primary-subdued-hovered': '#fff0ed',
    'action-primary-subdued-pressed': '#ffffff',
    'action-primary-disabled': '#f7f7f7',
    'action-neutral': '#ffffff',
    'action-neutral-hovered': '#f2f6fc',
    'action-neutral-pressed': '#edf4fd',
    'action-neutral-subdued': '#e6e6e6',
    'action-neutral-subdued-hovered': '#d4d4d4',
    'action-neutral-subdued-pressed': '#d4d4d4',
    'action-neutral-disabled': '#f7f7f7',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f2f2f2',
    background: '#FFFFFF',
    'background-hovered': '#f3f7fc',
    'background-pressed': '#FFEDEC',
    'background-selected': '#ffd3d1',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#a1a1a1',
    content: '#1a1c20',
    'content-subdued': '#353941',
    'content-muted': '#5b5e66',
    'content-hovered': '#26292f',
    'content-pressed': '#535353',
    'content-disabled': '#a1a1a1',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00294b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#ef5145',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f7f7f7',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#1a1c20',
    'content-on-background-subdued': '#26292f',
    'content-on-background-hovered': '#26292f',
    'content-on-background-pressed': '#f16157',
    'content-on-background-disabled': '#a1a1a1',
    interactive: '#ef5145',
    'interactive-hovered': '#f46e64',
    'interactive-pressed': '#e64438',
    'interactive-disabled': '#f7f7f7',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f7f7f7',
    topbar: '#f2f6fc',
    'topbar-subdued': '#ebf3ff',
    'content-on-topbar': '#060606',
    'line-on-topbar': '#d4d4d4',
    'line-on-topbar-pressed': '#727272',
    link: '#0f90ec',
    'link-hovered': '#006cb9',
    'link-pressed': '#0f90ec',
    line: '#bbc7d8',
    'line-subdued': '#ffffff',
    'line-hovered': '#a1a1a1',
    'line-pressed': '#727272',
    'line-selected': '#535353',
    'line-disabled': '#e6e6e6',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005791',
    'line-highlight-subdued': '#a5dbff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#0f90ec',
    skeleton: '#f2f6fc',
    surface: '#f2f6fc',
    'surface-subdued': '#ffffff',
    'surface-hovered': '#fafcff',
    'surface-subdued-hovered': '#fcfeff',
    'surface-pressed': '#e7f0ff',
    'surface-disabled': '#f7f7f7',
    'surface-selected': '#ffffff',
    'surface-selected-hovered': '#fff0ed',
    'surface-selected-pressed': '#ffe0da',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#cdebff',
    'surface-highlight-subdued': '#f0f8ff',
    'surface-highlight-subdued-hovered': '#e6f5ff',
    'surface-highlight-subdued-pressed': '#cdebff',
    'surface-neutral': '#ffffff',
    'surface-neutral-subdued': '#f7f7f7',
    'surface-inverse': '#171717',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark1: {
    'action-primary': '#ef5145',
    'action-primary-hovered': '#f46e64',
    'action-primary-pressed': '#e64438',
    'action-primary-subdued': '#252930',
    'action-primary-subdued-hovered': '#31353c',
    'action-primary-subdued-pressed': '#1a1d22',
    'action-primary-disabled': '#404040',
    'action-neutral': '#191B1E',
    'action-neutral-hovered': '#444951',
    'action-neutral-pressed': '#2f333a',
    'action-neutral-subdued': '#191B1E',
    'action-neutral-subdued-hovered': '#444951',
    'action-neutral-subdued-pressed': '#404040',
    'action-neutral-disabled': '#404040',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#404040',
    background: '#191B1E',
    'background-hovered': '#22262d',
    'background-pressed': '#FFC2C0',
    'background-selected': '#282828',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#2a2d32',
    content: '#fff3f2',
    'content-subdued': '#d3c9c9',
    'content-muted': '#a1a1a1',
    'content-hovered': '#f2f2f2',
    'content-pressed': '#d4d4d4',
    'content-disabled': '#727272',
    'content-on-positive': '#f4faf6',
    'content-on-attention': '#fff7f1',
    'content-on-highlight': '#f4f9fd',
    'content-on-negative': '#fff6f4',
    'content-on-negative-hovered': '#ffefec',
    'content-on-negative-pressed': '#ffdfda',
    'content-primary': '#ffefed',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#171717',
    'content-on-destructive': '#f7f7f7',
    'content-on-interactive': '#f7f7f7',
    'content-on-background': '#f7f7f7',
    'content-on-background-subdued': '#d4d4d4',
    'content-on-background-hovered': '#f2f2f2',
    'content-on-background-pressed': '#1A1D21',
    'content-on-background-disabled': '#727272',
    interactive: '#ef5145',
    'interactive-hovered': '#f46e64',
    'interactive-pressed': '#e64438',
    'interactive-disabled': '#171717',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#171717',
    topbar: '#15171a',
    'topbar-subdued': '#1A1D21',
    'content-on-topbar': '#f7f7f7',
    'line-on-topbar': '#404040',
    'line-on-topbar-pressed': '#727272',
    link: '#faaa9f',
    'link-hovered': '#f68475',
    'link-pressed': '#f68475',
    line: '#433f3f',
    'line-subdued': '#252a30',
    'line-hovered': '#535353',
    'line-pressed': '#727272',
    'line-selected': '#535353',
    'line-disabled': '#404040',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#041828',
    'line-highlight-subdued': '#041828',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#ff9c8f',
    skeleton: '#404040',
    surface: '#1B1F24',
    'surface-subdued': '#404040',
    'surface-hovered': '#191B1E',
    'surface-subdued-hovered': '#404040',
    'surface-pressed': '#535353',
    'surface-disabled': '#404040',
    'surface-selected': '#353c46',
    'surface-selected-hovered': '#3d444f',
    'surface-selected-pressed': '#2b313a',
    'surface-attention': '#3c220a',
    'surface-attention-subdued': '#5b3814',
    'surface-negative': '#4a1712',
    'surface-negative-subdued': '#712821',
    'surface-negative-subdued-hovered': '#90372e',
    'surface-negative-subdued-pressed': '#90372e',
    'surface-positive': '#0b2e1a',
    'surface-positive-subdued': '#17492d',
    'surface-highlight': '#092a42',
    'surface-highlight-subdued': '#154365',
    'surface-highlight-subdued-hovered': '#1f5880',
    'surface-highlight-subdued-pressed': '#1f5880',
    'surface-neutral': '#191B1E',
    'surface-neutral-subdued': '#404040',
    'surface-inverse': '#f7f7f7',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark2: {
    'action-primary': '#ef5145',
    'action-primary-hovered': '#f46e64',
    'action-primary-pressed': '#e64438',
    'action-primary-subdued': '#252930',
    'action-primary-subdued-hovered': '#31353c',
    'action-primary-subdued-pressed': '#1a1d22',
    'action-primary-disabled': '#404040',
    'action-neutral': '#171717',
    'action-neutral-hovered': '#282828',
    'action-neutral-pressed': '#404040',
    'action-neutral-subdued': '#282828',
    'action-neutral-subdued-hovered': '#404040',
    'action-neutral-subdued-pressed': '#404040',
    'action-neutral-disabled': '#282828',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#404040',
    background: '#1B1F24',
    'background-hovered': '#3B3232',
    'background-pressed': '#FFC2C0',
    'background-selected': '#404040',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#2a2d32',
    content: '#fff3f2',
    'content-subdued': '#d3c9c9',
    'content-muted': '#a1a1a1',
    'content-hovered': '#f2f2f2',
    'content-pressed': '#d4d4d4',
    'content-disabled': '#727272',
    'content-on-positive': '#f4faf6',
    'content-on-attention': '#fff7f1',
    'content-on-highlight': '#f4f9fd',
    'content-on-negative': '#fff6f4',
    'content-on-negative-hovered': '#ffefec',
    'content-on-negative-pressed': '#ffdfda',
    'content-primary': '#ffefed',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#171717',
    'content-on-destructive': '#f7f7f7',
    'content-on-interactive': '#f7f7f7',
    'content-on-background': '#f7f7f7',
    'content-on-background-subdued': '#FFE9E8',
    'content-on-background-hovered': '#f2f2f2',
    'content-on-background-pressed': '#1A1D21',
    'content-on-background-disabled': '#727272',
    interactive: '#ef5145',
    'interactive-hovered': '#f46e64',
    'interactive-pressed': '#e64438',
    'interactive-disabled': '#171717',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#171717',
    topbar: '#1A1D21',
    'topbar-subdued': '#15171a',
    'content-on-topbar': '#f7f7f7',
    'line-on-topbar': '#404040',
    'line-on-topbar-pressed': '#727272',
    link: '#faaa9f',
    'link-hovered': '#f68475',
    'link-pressed': '#f68475',
    line: '#433f3f',
    'line-subdued': '#252a30',
    'line-hovered': '#535353',
    'line-pressed': '#727272',
    'line-selected': '#535353',
    'line-disabled': '#404040',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#041828',
    'line-highlight-subdued': '#041828',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#faaa9f',
    skeleton: '#1f242a',
    surface: '#191B1E',
    'surface-subdued': '#24272b',
    'surface-hovered': '#24272c',
    'surface-subdued-hovered': '#404040',
    'surface-pressed': '#404040',
    'surface-disabled': '#282828',
    'surface-selected': '#33373d',
    'surface-selected-hovered': '#383c43',
    'surface-selected-pressed': '#2d3035',
    'surface-attention': '#3c220a',
    'surface-attention-subdued': '#5b3814',
    'surface-negative': '#4a1712',
    'surface-negative-subdued': '#712821',
    'surface-negative-subdued-hovered': '#90372e',
    'surface-negative-subdued-pressed': '#90372e',
    'surface-positive': '#0b2e1a',
    'surface-positive-subdued': '#17492d',
    'surface-highlight': '#092a42',
    'surface-highlight-subdued': '#154365',
    'surface-highlight-subdued-hovered': '#1f5880',
    'surface-highlight-subdued-pressed': '#1f5880',
    'surface-neutral': '#212426',
    'surface-neutral-subdued': '#404040',
    'surface-inverse': '#f7f7f7',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
}
